import { config } from 'lib-shared-backend-config';
import orderBy from 'lodash/orderBy';
import _sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { bindRtkActionToPromise } from 'app/utils/promiseActions';
import { currentAgentRoles } from 'components/shared/agentRole';
import { userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { websocketActions } from '../../../app/middleware/websocket/actions/websocket';
import * as conversationsActions from '../../conversation/actions/conversations';
import * as typingActions from '../../conversation/actions/typing';
import * as personalActions from '../../settings/actions/personal';
import { hasFeature } from '../../shared/featureFlag';
import { SidebarMenu } from '../components/sidebarMenu';
const { conversationsRemove } = conversationsActions.actions;
const { typingRemove } = typingActions.actions;
const { personalLeftMenu } = personalActions.actions;
const menuDevNotices = [];
if (config.backendDomain) {
    menuDevNotices.push({
        title: 'BD',
        label: `Backend Domain: ${config.backendDomain}`,
        onClose: () => {
            sessionStorage.removeItem('dixa:backend-domain');
            window.location.reload();
        },
    });
}
const statusMap = { working: 0, away: 1, offline: 2 };
const getPresence = (state) => state.presence;
const getPresenceByStatus = createSelector([getPresence], (presence) => {
    const sortedAllPresence = _sortBy(presence.allPresence, [
        function (element) {
            const rank = {
                working: 1,
                acw: 2,
                away: 3,
                offline: 4,
                unknown: 5,
            };
            return rank[element.presence.status];
        },
        function (element) {
            return element.user.name !== undefined && element.user.name !== null
                ? element.user.name.toLowerCase()
                : '';
        },
    ]);
    return sortedAllPresence.reduce((pre, userPresence) => {
        const { presence: { status }, } = userPresence;
        if (statusMap[status] !== undefined && pre[statusMap[status]]) {
            pre[statusMap[status]].push(userPresence);
        }
        return pre;
    }, [[], [], []]);
});
const getMetaConversations = (state) => state.conversations.metaConversations;
const sortMetaConversations = (item) => {
    if (item.conversation.status === 'open') {
        return 1;
    }
    if (['awaitingpending', 'pending'].includes(item.conversation.status || '')) {
        return 2;
    }
    if (item.conversation.status === 'closed') {
        return 3;
    }
    return 4;
};
const getMetaConversationsSorted = (state) => {
    return orderBy(getMetaConversations(state), [sortMetaConversations, 'isAssignedToMe', 'conversation.id'], ['asc', 'desc', 'desc']);
};
const BREAK_POINT_FOR_HIDING = 5;
const getMetaConversationsBeforeAndAfterBreak = createSelector([
    getMetaConversationsSorted,
    (state) => state.presence.presence.presence_status.load_descriptions.filter((load_description) => load_description.load_type === 'acw'),
    (state) => { var _a; return !!((_a = state.settings.profile.featureflags) === null || _a === void 0 ? void 0 : _a['required-custom-attribute']); },
], (metaConversations, loadDescriptions, requiredCustomAttribute) => {
    const before = [];
    const after = [];
    metaConversations.forEach((metaConversation, index) => {
        if (requiredCustomAttribute &&
            metaConversation.conversation.status === 'closed' &&
            loadDescriptions.some((loadDescription) => metaConversation.conversation.id === loadDescription.csid)) {
            before.unshift(metaConversation);
        }
        else if (index < BREAK_POINT_FOR_HIDING ||
            metaConversation.conversation.status === 'open') {
            before.push(metaConversation);
        }
        else {
            after.push(metaConversation);
        }
    });
    return { before, after };
});
const mapStateToProps = (state) => {
    var _a, _b;
    const { before, after } = getMetaConversationsBeforeAndAfterBreak(state);
    return {
        profile: state.settings.profile.profile,
        presence: state.presence,
        presenceByStatus: getPresenceByStatus(state),
        searchParams: state.search.params,
        metaConversation: state.conversation.metaConversation,
        metaConversations: state.conversations.metaConversations,
        metaConversationsBeforeBreak: before,
        metaConversationsAfterBreak: after,
        typings: state.typing.typings,
        dashboardLocationQueryParams: state.dashboard.meta.currentPageParams,
        conversationsLastSearchParams: state.conversationsPage.lastSearchParams,
        isMenuOpen: state.settings.personal.isLeftMenuOpen,
        widgetEnabled: (_b = (_a = state.widget.presence) === null || _a === void 0 ? void 0 : _a.show_widget) !== null && _b !== void 0 ? _b : false,
        menuDevNotices,
        agentRoles: currentAgentRoles(state.settings.profile.profile),
        hasSupportForTheNewDixaMessenger: hasFeature(state, 'use-the-new-dixa-messenger-in-agent-interface'),
        hasKnowledgeEnabled: hasFeature(state, 'knowledge-access'),
        hasAnalytics: hasFeature(state, 'custom-analytics'),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        showUserModal: () => dispatch(userModalActions.show({ user: { roles: ['agent'] } })),
        typingRemove: (typing) => dispatch(typingRemove(typing)),
        conversationsRemove: (csid) => dispatch(conversationsRemove(csid)),
        wsRequest: bindRtkActionToPromise(dispatch, websocketActions.request),
        personalLeftMenuToggle: bindActionToPromise(dispatch, personalLeftMenu),
    };
};
export const Menu = connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);
